import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/e08de581-f43d-4e93-9536-2fff2054ec7d";
export const REGISTER_URL = "https://a.ntrk2.com/59daae80-ab4e-4e6f-9792-c8f7cce6d0fe";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://getrichph.kzw2a.com/download?openExternalBrowser=1&id=5795ge8r88k0hl3";

export * from "./codes";
export * from "./context";
